export default "__VITE_ASSET__db8afa09__"